import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Entorno } from '../_models/entorno.model';
import { BehaviorSubject, map, Subject } from 'rxjs';

export interface EntornoParams {
    cantidadProductos?: number;
}

@Injectable({
  providedIn: 'root',
})
export class EntornoService {
  private http = inject(HttpClient);

  private apiUrl = `${environment.apiUrl}/Entorno`;

  private entornoSubject = new BehaviorSubject<Entorno>(null);
  public entorno$ = this.entornoSubject.asObservable();

  constructor() {}

  updateEntorno(params: EntornoParams = { cantidadProductos: 5 }) {
    const httpParams = new HttpParams({ fromObject: { ...params } });
    return this.http.get<Entorno>(`${this.apiUrl}`, { params: httpParams })
			.pipe(
				map((entorno) => {
					this.entornoSubject.next(entorno);
					return entorno;
				})
			);
  }
}
